/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StoragePolicySearchKey { 
    /**
     * The namespace
     */
    namespace: string;
    /**
     * The name of the transition type. Currently, only GLACIER and DESTROY-NON-RECORDS transition types are supported by the storage                   policies
     */
    transitionType?: string;
    /**
     * The status of the storage policy. Supported values are: ENABLED, DISABLED
     */
    status?: string;
}
